export default (theme) => ({
  container: {
    padding: 20,
    flexGrow: 1,
  },
});
